import { AppCard, AppPage } from '../../components/general';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useAuth } from '@mezzodevelopment/mezzo-ui/auth';
import { Waterfalls } from './Waterfalls';
import { useWaterfalls } from '../../hooks/useWaterfalls';
import { WaterfallViewModel } from '../../models/waterfall';

export const WaterfallsContainer = () => {
  const { user, isLoading: authIsLoading } = useAuth();
  const { waterfallsQuery, deleteWaterfall } = useWaterfalls();

  const isLoading = authIsLoading || !user || waterfallsQuery.isLoading;

  if (isLoading) {
    return (
      <AppPage title="Waterfalls" breadcrumbs="Admin - Waterfalls">
        <AppCard>
          <div className="flex flex-column align-items-center justify-content-center gap-2">
            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
            <span>Loading Waterfalls...</span>
          </div>
        </AppCard>
      </AppPage>
    );
  }

  return (
    <Waterfalls
      waterfalls={(waterfallsQuery.data ?? []) as WaterfallViewModel[]}
      onDelete={(id) => {
        if (id == null) return;
        deleteWaterfall(id);
      }}
    />
  );
};
